import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import { connect } from 'react-redux';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import './toast.sass';
import { Alert } from '@mui/material';
export const show_toast = (text, timeout = 5000) => (dispatch, getState) => {
    dispatch({ type: 'SHOW_TOAST', text });
    const orig_index = getState().toast.index;
    if (timeout) {
        setTimeout(() => {
            if (getState().toast.index === orig_index) {
                dispatch({ type: 'SHOW_TOAST', text: null });
            }
        }, timeout);
    }
};
const initial = { text: null, index: 0 };
export const reducer = (state = initial, action) => {
    switch (action.type) {
        case 'SHOW_TOAST':
            return { text: action.text, index: state.index + 1 };
        default:
            return state;
    }
};
class Toast extends Component {
    render() {
        return (_jsx("div", { className: "toast", children: _jsx("div", { className: "toast-content", children: _jsx(Alert, { severity: "error", children: this.props.children }) }) }));
    }
}
const ToastContainerImpl = (props) => (_jsx("div", { className: "toast-container", children: _jsx(TransitionGroup, { children: props.text != null && (_jsx(CSSTransition, { timeout: 200, classNames: "toast-fade", children: _jsx(Toast, { children: props.text }) }, props.index)) }) }));
export const ToastContainer = connect((state) => ({
    text: state.toast.text,
    index: state.toast.index,
}))(ToastContainerImpl);
